import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { html, LitElement, nothing } from 'lit'
import { customElement } from 'lit/decorators.js'
import { hostDisplayContents, totalPriceStyles } from 'components/ordering/quotation/components/quotation.style.js'
import { QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { NotFoundError } from 'components/ordering/quotation/api/dtos/error.js'
import { consume } from '@lit/context'
import { activeQuotationContext, NotFetchedYet } from 'components/ordering/quotation/components/context/quotation-context.js'
import { isQuotationDTO } from 'components/ordering/quotation/components/is-quotation-dto.js'

@customElement('csc-quotation-total-price')
export class CSCQuotationTotalPrice extends LitElement {
  static override styles = [hostDisplayContents, totalPriceStyles]

  @consume({ context: activeQuotationContext, subscribe: true })
  private quotation!: QuotationDTO | NotFoundError | NotFetchedYet

  override async connectedCallback() {
    super.connectedCallback()
  }

  override render() {
    if (!isQuotationDTO(this.quotation)) {
      return nothing
    }

    if (!this.quotation.showPrice) {
      return nothing
    }

    if (this.quotation.priceRequestMode && this.quotation.status === 'answered') {
      return nothing
    }

    return html`
      <div class="total">
        <div class="text">
          <cse-price as="span" size="s">
            ${t('total', { ns: 'csc-quotation-total-price', default: 'Total' })}
          </cse-price>

          <cse-text as="span" variant="caption-m">
            ${t('excluding_vat', { ns: 'csc-quotation-total-price', default: 'Excluding VAT' })}
          </cse-text>
        </div>

        <cse-price class="total-price" as="span" size="s">
          ${this.quotation.totalAmount}
        </cse-price>
      </div>
    `
  }
}
